module.exports = __webpack_public_path__ + "img/triangle3yellow.29ae066d.png";